document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var trigger = document.getElementById('cart-icon-trigger');
  var closeBtn = drawer ? drawer.querySelector('.cart-drawer-close') : null;

  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    var itemsHtml = '';
    if (cart.item_count === 0) {
      itemsHtml = '<p class="cart-drawer-empty">Your cart is empty.</p>';
    } else {
      cart.items.forEach(function (item) {
        itemsHtml += '' +
          '<div class="cart-drawer-item" data-key="' + item.key + '">' +
            '<img src="' + (item.image ? item.image.replace('{width}', '100') : '') + '" alt="' + item.title + '">' +
            '<div class="cart-drawer-item-info">' +
              '<div class="cart-drawer-item-title">' + item.product_title + '</div>' +
              '<div class="cart-drawer-item-variant">' + (item.variant_title || '') + '</div>' +
              '<div class="cart-drawer-item-qty-row">' +
                '<button class="qty-btn qty-minus">-</button>' +
                '<span class="cart-drawer-item-qty">' + item.quantity + '</span>' +
                '<button class="qty-btn qty-plus">+</button>' +
                '<span class="cart-drawer-item-remove">Remove</span>' +
              '</div>' +
            '</div>' +
            '<div class="cart-drawer-item-price">' + moneyFormat(item.line_price) + '</div>' +
          '</div>';
      });
    }
    drawer.querySelector('.cart-drawer-items').innerHTML = itemsHtml;
    drawer.querySelector('.cart-drawer-subtotal-price').textContent = moneyFormat(cart.total_price);

    // Dynamic $250 Minimum Spend Check & Checkout Button Lock
    if (typeof window.checkCartMinimum === 'function') {
      window.checkCartMinimum(cart.total_price);
    }
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(renderCart);
  }

  function openDrawer() {
    fetchCart();
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.classList.add('cart-drawer-locked');
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.classList.remove('cart-drawer-locked');
  }

  if (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var itemEl = e.target.closest('.cart-drawer-item');
      if (!itemEl) return;
      var key = itemEl.getAttribute('data-key');
      var qtyEl = itemEl.querySelector('.cart-drawer-item-qty');
      var qty = parseInt(qtyEl.textContent, 10);

      // Fetch the item's custom minimum quantity from the window object
      var minAllowed = (window.itemMinQuantities && window.itemMinQuantities[key]) 
        ? window.itemMinQuantities[key] 
        : 1;

      if (e.target.classList.contains('qty-plus')) {
        updateQty(key, qty + 1);
      } else if (e.target.classList.contains('qty-minus')) {
        // Enforce minimum limit on minus button
        if (qty <= minAllowed) {
          alert('Minimum order quantity for this item is ' + minAllowed + '.');
          return;
        }
        updateQty(key, qty - 1);
      } else if (e.target.classList.contains('cart-drawer-item-remove')) {
        // Always allow complete item removal
        updateQty(key, 0);
      }
    });
  }

  function updateQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateCartCountBadge(cart.item_count);
      });
  }

  function updateCartCountBadge(count) {
    var badge = document.querySelector('.cart_button .cart_count');
    if (badge) badge.textContent = ' (' + count + ')';
  }

  document.body.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('form[action^="/cart/add"]')) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              updateCartCountBadge(cart.item_count);
              openDrawer();
            });
        });
    }
  });
});